import { Typography } from "@mui/material";
import { forwardRef } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface MarkdownProps {
  content: string;
  size?: "small" | "normal";
  color?: "white" | "inherit";
}

export default forwardRef<HTMLDivElement, MarkdownProps>(
  ({ content, size = "normal", color = "inherit" }, ref) => {
    return (
      <Typography
        component="div"
        fontSize={size === "small" ? 12 : "inherit"}
        color={color}
        ref={ref}
        sx={{
          "& p": {
            m: 0,
            my: 0.25,
          },
          "& ul, & ol": {
            m: 0,
            whiteSpace: "normal",
            paddingLeft: "1.25em",
          },
          "& li": {
            marginBottom: 1,
            paddingLeft: 1,
          },
          "& a": {
            color,
          },
        }}
      >
        <ReactMarkdown
          children={content}
          remarkPlugins={[remarkGfm]}
          components={{
            a: ({ node, children, ...props }) => (
              <a {...props} target="_blank" rel="noopener noreferrer">
                {children}
              </a>
            ),
          }}
        />
      </Typography>
    );
  },
);
